'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * IT Footer Row
 */
ngModule.directive('itFooterRow', function () {
  return {
    restrict: "A",
    require: "^infiniTable",
    scope: true,
    link: function link($scope, $el, $attrs, tableCtrl) {
      var context = tableCtrl.getContext();
      var footerCellLinker = tableCtrl.linkers.footerCell;
      _.each(context.visibleColumns, function (computed) {
        var column = computed.column;
        var cellScope = $scope.$new();
        cellScope.column = computed;

        // add header row cell
        footerCellLinker(cellScope, function (footerCell) {
          computed.footerCellInjector(cellScope, footerCell);
          if (column.footerCellClass != null) {
            footerCell.addClass(column.footerCellClass);
          } else if (column.cellClass) {
            footerCell.addClass(column.cellClass);
          }
          computed.footerCell = footerCell;
          footerCell.appendTo($el);
        });
      });
      $('<td class="scrollbar">').appendTo($el);
    },
    controller: function controller($scope) {}
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/infiniTable/standard/itFooterRow.js
// module id = 2813
// module chunks = 13